import Auth, { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { Box } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { TFunction } from 'i18next'
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import appleIcon from '../../../assets/images/apple.svg'
import closeMenuIcon from '../../../assets/images/close.svg'
import emailIcon from '../../../assets/images/email.svg'
import googleIcon from '../../../assets/images/google-coloured.svg'
import { ROUTES } from '../../../constants'
import useBrandJoinFlow from '../../../hooks/useBrandJoinFlow'
import IOSSwitch from '../../IOSSwitch'
import CHRButton from '../../button'
import { styles } from './styles'
import Anchor from '../../anchor'

interface MainJoinModalProps {
  handleClose: any
  openStatus: boolean
  handleFinish: Function
  onIsTermsChecked: Function
  onIsNewsletterChecked: Function
  t: TFunction
}

const MainJoinModal = ({
  handleClose,
  openStatus,
  handleFinish,
  onIsTermsChecked,
  onIsNewsletterChecked,
  t,
}: MainJoinModalProps) => {
  const classes = styles()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const [isTermsChecked, setIsTermsChecked] = useState(true)
  const [isNewsletterChecked, setIsNewsletterChecked] = useState(true)

  const {
    joinFlowBrandName,
    generateBrandTrackingLinkForUser,
    getBrandDetailsFromStorage,
  } = useBrandJoinFlow()

  const handleTermsSwitch = () => {
    setIsTermsChecked(!isTermsChecked)
    onIsTermsChecked()
  }

  const handleNewslettersSwitch = () => {
    setIsNewsletterChecked(!isNewsletterChecked)
    onIsNewsletterChecked()
  }

  const onClose = () => {
    handleClose()

    if (joinFlowBrandName) {
      window.location.replace(
        generateBrandTrackingLinkForUser(
          getBrandDetailsFromStorage(),
          { userId: '0', username: '' },
          false
        )
      )
    }
  }

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={openStatus}
        onClose={onClose}
        aria-labelledby="createMainJoinModal"
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <button onClick={onClose} className={classes.closeButton}>
            <img src={closeMenuIcon} alt={t('imageAlts.close')} />
          </button>
          <Typography variant="h2" className={classes.modalTitle}>
            join chirpyest
          </Typography>
          <Typography variant="subtitle1">
            cash back from 1000s of retailers and top brands. join to shop,
            share and earn $$!
          </Typography>
          <div className={classes.btns}>
            <CHRButton
              onClick={() =>
                Auth.federatedSignIn({
                  provider: CognitoHostedUIIdentityProvider.Google,
                })
              }
              label={t('join.joinWithGoogle')}
              icon={googleIcon}
              customStyle={[classes.buttonStyles, classes.socialBtn].join(' ')}
            />
            {/* <CHRButton
                onClick={() =>
                  Auth.federatedSignIn({
                    provider: CognitoHostedUIIdentityProvider.Facebook,
                  })
                }
                label={t('join.joinWithFacebook')}
                icon={facebookIcon}
                customStyle={classes.buttonStyles}
              /> */}
            <CHRButton
              onClick={() =>
                Auth.federatedSignIn({
                  provider: CognitoHostedUIIdentityProvider.Apple,
                })
              }
              label={t('join.joinWithApple')}
              icon={appleIcon}
              customStyle={[classes.buttonStyles, classes.socialBtn].join(' ')}
            />
            <CHRButton
              onClick={handleFinish}
              label={
                <Box pl={joinFlowBrandName ? 4 : 0}>
                  <Box>
                    {t('join.joinWithEmail') as string}
                    {joinFlowBrandName ? ' & continue to' : ''}
                  </Box>
                  <Box>{joinFlowBrandName}</Box>
                </Box>
              }
              icon={emailIcon}
              customStyle={classes.buttonStyles}
            />
          </div>
          <div className={classes.switches}>
            <p className={classes.error}>
              {!isTermsChecked && t('join.termsAndConditions')}
            </p>
            <div className={classes.termsWrapper}>
              <IOSSwitch
                checked={isTermsChecked}
                onChange={handleTermsSwitch}
                name="terms"
              />
              <p className={classes.switchLabel}>
                {t('join.accept')}{' '}
                <span className={classes.bold}>
                  <Anchor
                    href={ROUTES.terms}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#000', textDecoration: 'none' }}
                  >
                    {t('join.termsAndPrivacy')}
                  </Anchor>
                </span>
              </p>
            </div>
            <div className={classes.termsWrapper}>
              <IOSSwitch
                checked={isNewsletterChecked}
                onChange={handleNewslettersSwitch}
                name="newsletters"
              />
              <p className={classes.switchLabel}>
                {t('join.subscribeToNewsletter')}
              </p>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default withTranslation()(MainJoinModal)
